import axios from "axios";
import { data } from "jquery";
import store from "../store";
const server = axios.create({
    time: 5000,
    withCredentials: false
})
//请求拦截
server.interceptors.request.use((config) => {
    config.url += '?SSOID=' + store.state.SSOID
    return config
}, err => {
    Promise.reject(err);
})
//响应拦截
server.interceptors.response.use((res) => {
    if (res.status == 200) {
        return res.data
    }
    return res
})
export default server;